import { render, staticRenderFns } from "./UserEditFamilyContactDetails.vue?vue&type=template&id=18c93776&"
import script from "./UserEditFamilyContactDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditFamilyContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEditFamilyContactDetails.vue?vue&type=style&index=0&id=18c93776&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports